import { Outlet } from 'react-router-dom';

export function SettingsLayout() {
  return (
    <div className="flex-1 overflow-y-auto">
      <Outlet />
    </div>
  );
}
